import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useTheme } from '@mui/material/styles';
import { shortWalletAdressDisplayStyles } from './shortWalletAdressDisplayStyles';
import { getShortAddress } from '../../helpers/getShortAddress';
import useMediaQuery from '@mui/material/useMediaQuery';

export interface IShortWalletAddressDisplayProps {
  userWalletAddress?: string;
}

export const ShortWalletAddressDisplay = ({
  userWalletAddress
}: IShortWalletAddressDisplayProps) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const classes = shortWalletAdressDisplayStyles(isDark, theme);
  const isDownXl = useMediaQuery(theme.breakpoints.down('xl'));
  const typographyVariant = isDownXl ? 'subtitle1' : 'h5';

  return (
    <Box sx={classes.shortWalletBox}>
      <Typography variant={typographyVariant} sx={classes.shortWallet}>
        {getShortAddress(userWalletAddress)}
      </Typography>
      <ArrowDropDownIcon color='primary' sx={classes.arrowIcon} />
    </Box>
  );
};
